import React from 'react'

interface FractionDisplayProps {
    whole_nmuber: number,
    numerator: number,
    denominator: number
}

const FractionDisplay: React.FC<FractionDisplayProps> = ({ whole_nmuber, numerator, denominator }) => {
    return (
        <div>
            {whole_nmuber !== 0 && (
                <span>{whole_nmuber}</span>
            )}
            {numerator !== 0 && denominator !== 0 && (
                <span>
                    <sup>{numerator}</sup>&frasl;<sub>{denominator}</sub>
                </span>
            )}
        </div>
    )
}

export default FractionDisplay